import styled from 'styled-components';

export const FooterWrapper = styled.div`
 width: 100%;
 background: transparent;
 margin:20px -20px 20px;
`
